<template>
    <input class="focus:ring-indigo-500 focus:border-indigo-500 block pr-10 sm:text-sm border-gray-300 rounded-md mt-1" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="input">
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['modelValue'],

        emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    })
</script>
